const ProsCheckmark = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect width="16" height="16" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.93103 5.86207L0 7.7931L5.7931 13.5862L15.4483 3.93103L13.5172 2L5.7931 9.72414L1.93103 5.86207Z"
                fill="#00A871"
            />
        </svg>
    );
};

export default ProsCheckmark;
